import api from "@/api";
import { PaginationModel } from "../types";

export default class MemberApi {
  static async list(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ) {
    return await api.get(`member/list`, options);
  }

  static async single(id: string) {
    return await api.get(`member/${id}`);
  }

  static async create(data: {}) {
    return await api.post(`member/`, data);
  }

  static async update(id: string, data: {}) {
    return await api.put(`member/${id}`, data);
  }

  static async delete(id: string) {
    return await api.del(`member/${id}`);
  }

  static async upload(data: any) {
    return await api.post(`member/uploadExcelFileToMember`,data);
  }
}
